function mapToFulfillmentType(fulFillmentType) {
  const fulfillmentTypes = {
    'pick-up': 'Takeout',
    delivery: 'Delivery',
    shipping: 'Shipping',
    'dine-in': 'DineIn',
    'room-service': 'RoomService'
  };

  const mappedType = fulfillmentTypes[fulFillmentType];

  return mappedType;
}

export default mapToFulfillmentType;
